import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import StoreRestockDefaultLocation from './StoreRestockDefaultLocation/StoreRestockDefaultLocation'
import * as Styles from './styles'

const RestockConfiguration = ({ inventoryLocationsByStore, onChangeLocation, storePreferences }) => {
  const { t } = useTranslation()

  const handleChangeLocation = (storeId, locationId) => {
    const updatedLocations = storePreferences.map(store => {
      if (store.store_id === storeId) {
        return { ...store, default_restock_location_id: locationId }
      }
      return store
    })
    onChangeLocation(updatedLocations)
  }

  return (
    <Styles.MainContainer>
      <Text type="titleM">{t('Reposición de productos')}</Text>
      <Text type="bodyMRegular">
        {t('Elige la sucursal donde quieres que se repongan por defecto los productos aceptados.')}
      </Text>
      <Styles.StoresContainer storesCount={storePreferences?.length}>
        {storePreferences?.map(store => (
          <StoreRestockDefaultLocation
            key={store.store_id}
            store={store}
            locations={inventoryLocationsByStore?.[store.store_id] || []}
            onChangeLocation={handleChangeLocation}
          />
        ))}
      </Styles.StoresContainer>
    </Styles.MainContainer>
  )
}

export default RestockConfiguration
